
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { iPCuentas } from '../models/iPlanCuenta.model';
@Injectable({
    providedIn: 'root'
})
export class PlanCuentaService {

    constructor(private apiService: ApiService, private http: HttpClient) { }

    insertar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.executePostJson(data).pipe();
    }

    modificar(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(cuenta: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.executeDeleteJson(`${cuenta}`)
    }

    obtener(cuenta: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`${cuenta}`)
    }

    obtener_columnna_compras(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`columnas-compras`)
    }

    obtener_colummna_ventas(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`columnas-ventas`)
    }

    obtener_clases_alternativas(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`clases-alternativas`)
    }
    /************************************************/

    buscarPlanCuenta(search: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`buscar?cuenta=${encodeURI(search.cuenta)}&nombre=${encodeURI(search.nombre)}&moneda=${encodeURI(search.moneda)}&imputable=${search.imputable}&limit=${search.limit}&offset=${search.offset}`);
    }

    obtenerPlanCuenta(cuenta: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`${cuenta}`)
    }

    eliminar_cuenta_alterna(cuenta: string, clase: number, codigo: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.executeDeleteJson(`${cuenta}/clases-alternativas/${clase}/${codigo}`)
    }

    eliminar_clase(cuenta: string, clase: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.executeDeleteJson(`${cuenta}/clases/${clase}`)
    }

    buscar_cuenta(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`list`)
    }

    obtener_columnas_compras(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`columnas-compras`)
    }

    buscar_cuenta_nivel(nivel: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.plan_cuenta_url);
        return this.apiService.execGetQueryJson(`listByNivel?nivel=${nivel}`)
    }
    /**************SELECT MODAL CLASES*******************/

    pcuentas_obtener_clases(): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas');
        return this.apiService.execGetQueryJson(`/plan-cuentas/clases`)
    }

    pcuentas_obtener_clases_codigos(clase: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas');
        return this.apiService.execGetQueryJson(`/plan-cuentas/clases/${clase}/codigos`)
    }

}


